import axios, { AxiosError, AxiosInstance, AxiosResponse } from "axios";
import { BASE_URL } from "./config";

const axiosInstance: AxiosInstance = axios.create({
    baseURL: BASE_URL,
    timeout: 100000,
    headers: { Accept: "application/json" }
});
const pendingRequests = new Map<string, Promise<AxiosResponse<any>>>();

axiosInstance.interceptors.request.use(
    (config) => {
        if (config.data instanceof FormData) {
            config.headers["Content-Type"] = "multipart/form-data";
        } else {
            config.headers["Content-Type"] = "application/json";
        }
        return config;
    },
    (error: AxiosError) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
        console.log("API Success Response in axios instance", response);
        return response;
    },
    (error: AxiosError) => {
        if (error.response) {
            console.error("API Error:", error.response);
        } else {
            console.error("Network Error:", error.message);
        }
        // console.log("BASE_URL", BASE_URL);

        return Promise.reject(error);
    }
);

export default axiosInstance;
